import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { black } from "designSystem/styles/color";
import { Box, Button } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";

export default () => (
	<Box
		bgcolor={black[50]}
		height="auto"
		margin="auto"
		padding={2}
		width="auto"
	>
		<CssColumnGrid columns={3}>
			<Button design="darkMode">Dark Mode</Button>
			<Button
				design="darkMode"
				endIcon={<ArrowDropDownIcon />}
			>
                Dark Mode
			</Button>
			<Button design="darkModePrimary">Dark Mode Primary</Button>
			<Button design="darkMode" disabled>Dark Mode</Button>
			<Button
				design="darkMode"
				disabled
				endIcon={<ArrowDropDownIcon />}
			>
                Dark Mode
			</Button>
			<Button design="darkModePrimary" disabled>Dark Mode Primary</Button>
		</CssColumnGrid>
	</Box>
);